import { render, staticRenderFns } from "./SmsHistory.vue?vue&type=template&id=6844682a&scoped=true"
import script from "./SmsHistory.vue?vue&type=script&lang=js"
export * from "./SmsHistory.vue?vue&type=script&lang=js"
import style0 from "./SmsHistory.vue?vue&type=style&index=0&id=6844682a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6844682a",
  null
  
)

export default component.exports